import { GlobalConfig } from '@/types/interfaces';

export function storeConfig(state: GlobalConfig, config: GlobalConfig) {
  Object.entries(config).forEach(([key, value]: [string, string]) => {
    state[key as keyof GlobalConfig] = value;
  });
}
